import React from 'react';
import { motion } from 'framer-motion';
import { FuelIcon, FlameIcon, ZapIcon } from 'lucide-react';
const columns = [{
  icon: FuelIcon,
  title: 'Shell Tankstelle',
  features: ['20 Zapfsäulen', 'AdBlue', 'LPG'],
  color: 'text-red-500',
  glow: 'rgba(239, 68, 68, 0.2)',
  bgColor: 'bg-red-500/10'
}, {
  icon: FlameIcon,
  title: 'LNG-Säule',
  features: ['Flüssigerdgas für LKW', '24/7 verfügbar', 'Sichere Betankung'],
  color: 'text-blue-400',
  glow: 'rgba(96, 165, 250, 0.2)',
  bgColor: 'bg-blue-400/10'
}, {
  icon: ZapIcon,
  title: 'IONITY Ladestation',
  features: ['Hochleistungs-Schnellladen', '100% Ökostrom', 'Alle gängigen Stecker'],
  color: 'text-neon-green',
  glow: 'rgba(34, 197, 94, 0.2)',
  bgColor: 'bg-neon-green/10'
}];
export function EnergyHub() {
  return <section className="py-32 px-4 w-full bg-base relative overflow-hidden" data-id="element-113">
      {/* Tech Background Pattern */}
      <div className="absolute inset-0 opacity-[0.03] bg-[linear-gradient(rgba(255,255,255,0.1)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.1)_1px,transparent_1px)] bg-[size:40px_40px]" data-id="element-114" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-115">
        <div className="text-center mb-20" data-id="element-116">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-5xl md:text-6xl font-heading font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-neon-green to-electric-blue" data-id="element-117">
            Energy Hub
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-white/60 max-w-2xl mx-auto font-body" data-id="element-118">
            Die Energie der Zukunft, heute schon verfügbar. Egal welcher
            Antrieb, wir bringen Sie weiter.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-119">
          {/* Animated Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-red-500/20 via-blue-400/20 to-neon-green/20 -translate-y-1/2 z-0" data-id="element-120" />

          {columns.map((col, idx) => {
          const Icon = col.icon;
          return <motion.div key={col.title} initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.2
          }} whileHover={{
            y: -10
          }} className="glass-card p-8 rounded-[2rem] relative z-10 bg-[#0a0a0a] border-white/10" style={{
            boxShadow: `0 20px 40px -20px ${col.glow}`
          }} data-id="element-121">
                <div className={`w-14 h-14 rounded-2xl ${col.bgColor} flex items-center justify-center mb-6`} data-id="element-122">
                  <Icon className={`w-7 h-7 ${col.color}`} strokeWidth={1.5} data-id="element-123" />
                </div>
                <h3 className={`text-2xl font-heading font-bold mb-6 ${col.color}`} data-id="element-124">
                  {col.title}
                </h3>
                <ul className="space-y-4" data-id="element-125">
                  {col.features.map((feat, i) => <li key={i} className="flex items-center gap-3 text-white/70" data-id="element-126">
                      <div className={`w-1.5 h-1.5 rounded-full ${col.color.replace('text-', 'bg-')}`} data-id="element-127" />
                      {feat}
                    </li>)}
                </ul>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}